import "aos/dist/aos.css";
import Share from "./Share";
import toast from "react-hot-toast";
import CommentReport from "./CommentReport";
import "react-multi-carousel/lib/styles.css";
import { Button } from "@material-tailwind/react";
import { TiUserAddOutline } from "react-icons/ti";
import { FaHeart, FaRegHeart } from "react-icons/fa";
import WelcomeModal from "../Modals/WelcomeModal";
import ClipLoader from "react-spinners/ClipLoader";
import Comments from "./Comments";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { IoCaretBackCircleSharp } from "react-icons/io5";
import { videoFootageSideIcon } from "../../assets/data/Datas";
import { useLocation, useNavigate } from "react-router-dom";
import { videoView } from "../../redux/ApiSlice/VideoViewSlice";
import emptyComments from "../../assets/icons/homeIcon//comments.svg";
import { handleProfileNavigate } from "../../utils/handleProfileNavigate";
import { timeAgo } from "../../utils/timeUtils";
import { SavedVideosById } from "../../redux/ApiSlice/HomePageVideoSlice";
import { accountBlockUser, updatePostLikeStatus } from "../../redux/ApiSlice/AccountProfileSlice";
import Hls from "hls.js";
import { useCallback, useEffect, useRef, useState, memo, useMemo } from "react";
import { commentCountIncrease, commentCountDecrease, friendsFeeds, HomepageVideoLike, removeVideoLike, setVideoLike, trackWatchVideo } from "../../redux/ApiSlice/HomePageVideoSlice";
import {
    CommentDelete,
    commentReplyDelete,
    commentReport,
    CreateComment,
    DeleteComment,
    deleteNestedReply,
    updateCommentReply,
    getCommentReply,
    ReplayComment,
    replyNestedReply,
    UpdateComment,
    updateNestedReply
} from "../../redux/ApiSlice/CommentsSlice";
import { getRecentFriendList } from "../../redux/ApiSlice/ShareSlice";
import { formatCount } from "../../utils/formatCount";
import { isOwnLikeCountHidden } from "../../utils/userPreferences";

const HomeVideoView = ({
    id,
    src,
    created_by,
    created_at,
    comments,
    dec,
    thumbnail_url,
    handleReshared,
    user_liked,
    user_saved,
    userreshared,
    newUser,
    handleReadUserStatus,
    resharedPostId,
    rehsaredMesaage,
    setResharedPostId,
    userfollowing,
    handleFollowFun,
    itsNotHome,
    handleSliderStart,
    handleSliderEnd,
    isFollow,
    handleRefresh,
    showWelcome,
    comments_enabled,
    download_enabled,
    playbackSpeed,
    setPlaybackSpeed,
    videoId,
    yourFeeds,
    videos,
    videoCommentCount,
    videoLikeCount,
    userLogin,
    handleInteraction = () => console.warn('handleInteraction not provided'),
    enableAutoplay = false,
    muteVideosByDefault = false,
    handleNext,
    exitReasonHint = "swiped_away",
    reported,
    reportedPostIdsRef,
    onMarkAsReported,
    onRemoveReported,
    isActive = true, // true = this is the visible slide; false = buffering off-screen
    onVideoReady,
    // loading
}) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const location = useLocation();

    // Access the state passed from navigation
    const { from: prevPath, feedType, fromComment } = location.state || {};

    const { homePageVideos, currentIndex, videoData = [], loading, initialLoading } = useSelector(
        (state) => state.HomePageVideo,
        shallowEqual
    );
    const [isSaved, setIsSaved] = useState(false);
    const [likeEmoji, setLikeLikeEmoji] = useState(false);
    const [isLikeAnimating, setIsLikeAnimating] = useState(false);
    const [hasUserInteracted, setHasUserInteracted] = useState(false);
    const [isVideoInView, setIsVideoInView] = useState(false);
    const [isRepostAnimating, setIsRepostAnimating] = useState(false);
    const [likeCount, setLikeCount] = useState(0);
    const [commentCount, setCommentCount] = useState(0);
    const [isReshared, setIsReshared] = useState(false);
    const [openBottom, setOpenBottom] = useState(false);
    const openDrawerBottom = () => {
        dispatch(getRecentFriendList());
        setOpenBottom(true);
    }
    const closeDrawerBottom = () => setOpenBottom(false);
    const [openBottomComments, setOpenBottomComments] = useState(fromComment || false);
    // const [openSaveDrawer, setOpenSaveDrawer] = useState(false);
    const [createCommet, setCreateComment] = useState({ key: id, body: "" });
    const [createReplay, setCreateReplay] = useState({ key: id, body: "" });
    // const [feedEmpty, setFeedEmpty] = useState(false);
    const [menuCommentId, setMenuCommentId] = useState(null);
    const menuRef = useRef(null);
    const saveRef = useRef(null);
    const [EditComment, setEditComment] = useState(false);

    const [replay, setReplay] = useState(false);
    const [editReply, setEditReply] = useState(false);
    const [editNestedReply, setEditNestedReply] = useState(false);
    const videoRef = useRef(null);
    const playPromiseRef = useRef(null);
    const isVideoInViewRef = useRef(false);
    const isActiveRef = useRef(isActive);
    const [repleyitemId, setRepleyItemId] = useState(null);
    const [commentPrev, setCommentPrev] = useState({});
    const [showReshareMessage, setShowReshareMessage] = useState(false);
    const [showReportSuccess, setShowReportSuccess] = useState(false);
    const reshareMessageTimeoutRef = useRef(null);
    const watchPositionRef = useRef(0);
    const watchDurationRef = useRef(0);
    const progressIntervalRef = useRef(null);
    const initialSentRef = useRef(false);
    const lastExitReasonRef = useRef(null);
    const milestone50SentRef = useRef(false);
    const milestone95SentRef = useRef(false);

    // Show More Desc For Video
    const [showMore, setShowMore] = useState(false);
    const textRef = useRef(null);
    const [reportModal, setReportModal] = useState(false);
    const [viewAPITriggered, setViewAPITriggered] = useState(false);
    const [progress, setProgress] = useState(0);
    const [duration, setDuration] = useState(0);
    const [isHovered, setIsHovered] = useState(false);
    const [isDragging, setIsDragging] = useState(false);
    const [nestedReply, setNestedReply] = useState(false);
    const [commentsData, setCommentsData] = useState([]);
    const [showBlockConfirm, setShowBlockConfirm] = useState(false);
    const [userToBlock, setUserToBlock] = useState(null);
    const [usersfollowing, setUsersFollowing] = useState(false);
    const [followLoading, setFollowLoading] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    // Start muted so autoplay is never blocked by the browser's autoplay-with-sound
    // policy; once the user has interacted with the page, unmute unless their
    // preference explicitly asks for muted-by-default playback.
    const [isMuted, setIsMuted] = useState(true);
    const loopCountRef = useRef(0);
    const lastPlaybackTimeRef = useRef(0);
    const sessionIdRef = useRef(null);

    useEffect(() => {
        setUsersFollowing(userfollowing ?? false);
    }, [userfollowing])

    useEffect(() => {
        const markInteracted = () => {
            setHasUserInteracted(true);
            window.removeEventListener("pointerdown", markInteracted);
            window.removeEventListener("keydown", markInteracted);
        };

        window.addEventListener("pointerdown", markInteracted);
        window.addEventListener("keydown", markInteracted);

        return () => {
            window.removeEventListener("pointerdown", markInteracted);
            window.removeEventListener("keydown", markInteracted);
        };
    }, []);

    // Keep the video's actual mute state in sync with the user's preference:
    // stay muted if they asked for muted-by-default, otherwise unmute once
    // they've interacted with the page.
    useEffect(() => {
        setIsMuted(muteVideosByDefault ? true : !hasUserInteracted);
    }, [muteVideosByDefault, hasUserInteracted]);

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.muted = isMuted;
        }
    }, [isMuted]);

    useEffect(() => {
        watchPositionRef.current = 0;
        watchDurationRef.current = 0;
        initialSentRef.current = false;
        lastExitReasonRef.current = null;
        loopCountRef.current = 0;
        lastPlaybackTimeRef.current = 0;
        sessionIdRef.current = null;
        milestone50SentRef.current = false;
        milestone95SentRef.current = false;
        setIsPlaying(false);
        setViewAPITriggered(false);
        setIsLoading(true); // reset so thumbnail shows until new video is ready
    }, [id]);

    const getSessionIdFromCookie = () => {
        if (typeof document === "undefined") return null;

        const cookie = document.cookie || "";
        const getCookieValue = (name) => {
            const parts = cookie.split(";").map((part) => part.trim());
            const match = parts.find((part) => part.toLowerCase().startsWith(`${name.toLowerCase()}=`));
            if (!match) return null;
            const value = match.substring(match.indexOf("=") + 1);
            return value ? decodeURIComponent(value) : null;
        };

        return (
            getCookieValue("sessionid") ||
            getCookieValue("session_id") ||
            getCookieValue("sessionId") ||
            localStorage.getItem("sessionid") ||
            localStorage.getItem("session_id") ||
            localStorage.getItem("sessionId") ||
            sessionStorage.getItem("sessionid") ||
            sessionStorage.getItem("session_id") ||
            sessionStorage.getItem("sessionId") ||
            null
        );
    };

    // Add debounce for timeline updates to prevent excessive re-renders during scroll
    const timeUpdateRef = useRef(null);
    const lastProgressRef = useRef(0);
    const lastDurationRef = useRef(0);

    useEffect(() => {
        let currentVideo;

        if (videoId) {
            if (Array.isArray(videoData) && videoData.length > 0) {
                currentVideo = videoData.find(video => video.id === videoId);
            }
            if (!currentVideo) {
                currentVideo = homePageVideos?.find(video => video.id === videoId);
            }
        } else {
            currentVideo = homePageVideos?.find(video => video.id === id)
                ?? homePageVideos?.[currentIndex];
        }

        if (!currentVideo) return;

        setLikeCount(currentVideo.likes_count ?? 0);
        setCommentCount(currentVideo.comment_thread_count ?? 0);
        setIsSaved(currentVideo.usersaved);
        setLikeLikeEmoji(currentVideo.userliked ?? false);
        setUsersFollowing(currentVideo.userfollowing ?? false);
        setIsReshared(currentVideo.userreshared ?? false);
    }, [id, videoId, currentIndex, videoData, homePageVideos]);

    //
    // Memoized text processing to prevent unnecessary recalculations
    const { hashtags, description, isLongText, displayText } = useMemo(() => {
        const text = dec || "";
        // Extract hashtags more reliably
        const hashtagRegex = /#\w+/g;
        const extractedHashtags = text.match(hashtagRegex) || [];

        // Remove hashtags from description to get clean text
        const cleanDescription = text.replace(hashtagRegex, "")?.trim();
        const maxLength = 22;

        // Check if TOTAL content (description + hashtags) is long
        const totalContentLength = cleanDescription.length + extractedHashtags.join(' ').length;
        const isContentLong = totalContentLength > maxLength;

        // For display purposes, keep original text structure for short content
        const shouldShowFullText = !isContentLong;

        return {
            hashtags: extractedHashtags,
            description: cleanDescription,
            isLongText: isContentLong,
            displayText: shouldShowFullText ? text : cleanDescription // Use original text for short content
        };
    }, [dec]);    // Optimized hashtag click handler

    const handleHashtagClick = useCallback((hashtag) => {
        navigate(`/hashtag/${hashtag}`);
    }, [navigate]);

    // Optimized show more toggle
    const handleShowMore = useCallback(() => {
        setShowMore(prev => !prev);
    }, []);

    // Memoized hashtag component to prevent unnecessary re-renders
    const HashtagList = useMemo(() => {
        if (!hashtags.length) return null;

        return (
            <div className="mt-1 flex flex-wrap">
                {hashtags.map((item, index) => (
                    <a
                        key={index}
                        onClick={() => handleHashtagClick(item)}
                        className="underline text-[12px] text-white cursor-pointer px-[2px] mr-1.5"
                    >
                        {item}
                    </a>
                ))}
            </div>
        );
    }, [hashtags, handleHashtagClick]);

    // Memoized description display logic
    const DescriptionContent = useMemo(() => {
        const maxLength = 22;

        if (!isLongText) {
            // For short content, show description only (hashtags will be shown separately)
            return <p>{description}</p>;
        } else {
            // For long content, show truncated or full description based on showMore state
            return (
                <p>
                    {!showMore ? `${description.slice(0, maxLength)}` : description}
                    {!showMore && (
                        <span
                            onClick={handleShowMore}
                            className="text-[12px] ml-1 cursor-pointer font-bold text-cyan-500 hover:text-cyan-400"
                        >
                            ...more
                        </span>
                    )}
                </p>
            );
        }
    }, [description, isLongText, showMore, handleShowMore]);

    // Optimized follow button handler
    const handleFollowClick = useCallback((userId) => {
        handleFollowFun(userId);
    }, [handleFollowFun]);

    // Optimized report modal closer
    const handleCloseReportModal = useCallback(() => {
        setReportModal(null);
    }, []);

    // Block user handlers
    const setBlockUser = useCallback((user) => {
        setUserToBlock(user);
        setShowBlockConfirm(true);
    }, []);

    const handleBlockConfirm = async () => {
        if (!userToBlock) return;

        try {
            const response = await dispatch(accountBlockUser(userToBlock.id));
            if (response.payload?.message) {
                toast.success(`${userToBlock.full_name} has been blocked successfully`, {
                    duration: 3000,
                    position: "top-right",
                    style: {
                        background: "#333",
                        color: "#fff",
                        fontSize: "14px",
                    },
                });
                setShowBlockConfirm(false);
                setUserToBlock(null);
            }
        } catch (error) {
            console.error("Error blocking user:", error);
            toast.error("Failed to block user", {
                duration: 3000,
                position: "top-right",
                style: {
                    background: "#333",
                    color: "#fff",
                    fontSize: "14px",
                },
            });
        }
    };

    const handleBlockCancel = () => {
        setShowBlockConfirm(false);
        setUserToBlock(null);
    };

    const openDrawerBottomComments = async () => {
        setOpenBottomComments(true);
    };

    const ProfileDetails = useSelector((state) => state.AccountProfile);
    const { User_profile } = ProfileDetails;
    const hideOwnLikeCount = isOwnLikeCountHidden(created_by?.id, User_profile?.id);

    const closeDrawerBottomCommments = () => {
        setOpenBottomComments(false)
        setRepleyItemId(null);
        setReplay(false);
        setCreateReplay({ key: id, body: "" });
        setEditComment(false);
        setCreateComment({ key: id, body: "" });
    };

    // const handleOpenSavedModal = () => setOpenSaveDrawer(!openSaveDrawer);
    // useOutsideClick(saveRef, () => handleOpenSavedModal());

    const handleOpenreplay = (value) => {
        setRepleyItemId(value);
    };

    let originalURL = User_profile.avatar;

    const toggleMenu = (commentId) => {
        if (menuCommentId === commentId) {
            setMenuCommentId(null); // Close menu if already open
        } else {
            setMenuCommentId(commentId); // Open menu for this comment
        }
    };


    const handleLikeVideo = useCallback(async () => {
        setIsLikeAnimating(true);

        // Set a timeout to reset animation state
        setTimeout(() => {
            setIsLikeAnimating(false);
        }, 500);

        // Optimistic UI update
        const previousLikeState = likeEmoji;
        const previousLikeCount = likeCount;
        setLikeLikeEmoji(!previousLikeState);
        setLikeCount(previousLikeState ? likeCount - 1 : likeCount + 1);

        try {
            const responce = await dispatch(HomepageVideoLike(id));
            if (responce.payload?.message === "like removed") {
                setLikeLikeEmoji(false);
                dispatch(removeVideoLike(id));
                dispatch(updatePostLikeStatus({ postId: id, isLiked: false }));
            } else {
                setLikeLikeEmoji(true);
                dispatch(setVideoLike(id));
                dispatch(updatePostLikeStatus({ postId: id, isLiked: true }));
            }
        } catch (error) {
            // Revert on error
            setLikeLikeEmoji(previousLikeState);
            setLikeCount(previousLikeCount);
            console.error("Error liking video:", error);
        }
    }, [id, dispatch, likeEmoji, likeCount]);

    const handleRepostWithAnimation = async (id) => {
        setIsRepostAnimating(true);

        // Reset animation after it completes
        setTimeout(() => {
            setIsRepostAnimating(false);
        }, 800);
        //        // Call the original repost handler
        handleReshared(id);
    };

    const handleSetPage = (value) => {
        if (!userLogin) {
            handleInteraction();
        } else {
            switch (value) {
                case "Repost":
                    handleRepostWithAnimation(id);
                    if (isPlaying) sendProgressTracking();
                    return;
                case "Comment":
                    return openDrawerBottomComments();
                case "Share":
                    openDrawerBottom();
                    if (isPlaying) sendProgressTracking();
                    return;
                case "Like":
                    handleLikeVideo();
                    if (isPlaying) sendProgressTracking({ liked: !likeEmoji });
                    return;
                case "Save":
                    handleSaveVideo(id);
                    if (isPlaying) sendProgressTracking();
                    return;
                default:
                    break;
            }
        }
    };

    const handleSaveVideo = async (id) => {
        try {
            await dispatch(SavedVideosById(id));
        } catch (error) {
            console.error("Error saving video:", error);
        }
    };

    const handleReportSuccess = useCallback(() => {
        if (onMarkAsReported) {
            onMarkAsReported(id);
        }
        setShowReportSuccess(true);
        if (videoRef.current && !videoRef.current.paused) {
            videoRef.current.pause();
            setIsPlaying(false);
        }
    }, [id, onMarkAsReported]);

    const handleCloseReportSuccess = useCallback(() => {
        if (onRemoveReported) {
            onRemoveReported(id);
        }
        setShowReportSuccess(false);
    }, [id, onRemoveReported]);

    const handleOpenReportCenter = useCallback(() => {
        setShowReportSuccess(false);
        navigate("/report-center");
    }, [navigate]);

    useEffect(() => {
        if (reshareMessageTimeoutRef.current) {
            clearTimeout(reshareMessageTimeoutRef.current);
            reshareMessageTimeoutRef.current = null;
        }

        if (resharedPostId === id && rehsaredMesaage) {
            setShowReshareMessage(true);
            reshareMessageTimeoutRef.current = setTimeout(() => {
                setShowReshareMessage(false);
                reshareMessageTimeoutRef.current = null;
            }, 5000);
        } else {
            setShowReshareMessage(false);
        }

        return () => {
            if (reshareMessageTimeoutRef.current) {
                clearTimeout(reshareMessageTimeoutRef.current);
                reshareMessageTimeoutRef.current = null;
            }
        };
    }, [resharedPostId, rehsaredMesaage, id]);

    const handleChangeComment = (e) => {
        setCreateComment((prev) => ({ ...prev, body: e.target.value }));
    };

    const handleChangeReply = (e) => {
        setCreateReplay((prev) => ({ ...prev, body: e.target.value }));
    };

    const handleSubmitComment = async () => {
        if (EditComment) {

            try {
                const response = await dispatch(UpdateComment(createCommet));

                if (response.payload?.id) {

                    setCommentsData((prev) => {
                        return prev.map((item) => {
                            if (item.id === createCommet.key) {
                                return response.payload;
                            }
                            return item;
                        });
                    }
                    );
                }

                setEditComment((prev) => !prev);

            } catch (error) {
                console.error("Error updating comment:", error);
            }

        }

        // else if (replay) {
        //     await dispatch(ReplayComment(createCommet));
        //     dispatch(GetComment(id));
        //     setReplay((prev) => !prev);
        // } 

        else {
            if (createCommet.body.length > 0) {
                const response = await dispatch(CreateComment({ key: id, body: createCommet.body }));
                await dispatch(commentCountIncrease({ postId: id }))

                if (response.payload?.id) {
                    setCommentsData((prev) => [response.payload, ...prev]);
                }
            }
        }
        setCreateComment({ key: id, body: "" });
    };

    const handleSubmitReplay = async (commentId, postId) => {
        if (nestedReply) {
            handleReplyNestedReply(commentId)
        } else {
            if (createReplay.body.length > 0) {
                await dispatch(ReplayComment(createReplay));
                await dispatch(commentCountIncrease({ postId: id }))
                setCommentsData((prev) => {
                    return prev.map((item) => {
                        if (item.id === commentPrev.id) {
                            return {
                                ...item,
                                reply_count: item.reply_count + 1,
                            };
                        }
                        return item;
                    });
                });
                setCreateReplay({ key: id, body: "" });
                setRepleyItemId(null);
                getCommentRepliesByCommentId(commentPrev.id)
            }
        }

    }

    const closeEditComment = () => {
        setEditComment((prev) => !prev);
        setCreateComment({ key: null, body: "" });
    }

    const handleCloseReply = () => {
        setRepleyItemId(null);
        setReplay(false);
        setCreateReplay({ key: null, body: "" });
    }

    const handleChangeEditComment = (data) => {
        setCommentPrev(data);
        setCreateComment(() => ({
            key: data.id, body: data.post_comment_box
        }));
        setEditComment((prev) => !prev);
        setMenuCommentId(null);
    };

    const handleEditReply = (data, nested) => {
        if (nested) {
            setEditNestedReply(true);
        } else {
            setEditReply((prev) => !prev);
        }
        setCommentPrev(data);
        setCreateReplay(() => ({
            key: data.id, body: data.post_comment_box
        }));
        setRepleyItemId(data.id);
    }

    const handleChangeDeleteComment = async (CommentId) => {
        try {
            // Dispatch the delete comment action
            await dispatch(DeleteComment(CommentId));
            // Remove the comment from the local state
            setCommentsData((prev) => prev.filter((item) => item.id !== CommentId));
            dispatch(commentCountDecrease({ postId: id }));
            // Reset the menu comment ID
            setMenuCommentId(null);
        } catch (error) {
            // Handle errors
            console.error("Error deleting comment:", error);

            // Show an error message
            toast.error("An error occurred while deleting the comment.", {
                duration: 3000,
                position: "top-right",
                style: {
                    background: "#333",
                    color: "#fff",
                    fontSize: "14px",
                },
            });
        }
    };

    const handleChangeRepleyComment = (data, is_nested_reply) => {
        if (is_nested_reply) {
            setNestedReply(true);
            setCommentPrev(data);
            setCreateReplay(() => ({ key: data.id, body: "" }));
            setReplay(true);
            setRepleyItemId(data.id);
            setMenuCommentId(null);

        } else {
            setNestedReply(false);
            setCommentPrev(data);
            setCreateReplay(() => ({ key: data.id, body: "" }));
            setReplay(true);
            setRepleyItemId(data.id);
            setMenuCommentId(null);
        }
    };

    const handleReplyNestedReply = async (commentId) => {
        const data = { body: createReplay.body, key: repleyitemId };
        try {
            const response = await dispatch(replyNestedReply(data));
            if (response.payload?.id) {
                getCommentRepliesByCommentId(commentId);
                setRepleyItemId(null);
                setReplay(false);
                setCreateReplay({ key: id, body: "" });
            }

        } catch (error) {
            console.error("Error:", error);

            // Extract the error message from the response
            const errorMessage = error?.payload?.message || "An error occurred while replying to the comment.";
            toast.error(errorMessage, {
                duration: 3000,
                position: "top-right",
                style: {
                    background: "#333",
                    color: "#fff",
                    fontSize: "14px",
                },
            });

        }
    }

    const deleteCommentReply = async (replyId, commentId) => {
        try {
            await dispatch(commentReplyDelete({ replyId, commentId }));
            setTimeout(() => {
                setRepleyItemId(null);
                setReplay(false);
                setCreateReplay({ key: id, body: "" });
            }, 3000);

            setCommentsData((prev) => {
                return prev.map((item) => {
                    if (item.id === commentId) {
                        return {
                            ...item,
                            reply_count: item.reply_count - 1,
                        };
                    }
                    return item;
                });
            });
            getCommentRepliesByCommentId(commentId);
        }
        catch (error) {
            console.error("Error deleting comment reply:", error);
        }
    };

    const handleReportComment = async (reason, message = "") => {
        const data = {
            key: "reason",
            value: reason,
            ...(message && { message })
        };
        const response = await dispatch(commentReport({ commentId: reportModal, data }));
        if (response.payload?.id) {
            toast.success("Comment reported successfully", {
                duration: 3000,
                position: "top-right",
                style: {
                    background: "#333",
                    color: "#fff",
                    fontSize: "14px",
                },
            });
            setTimeout(() => {
                setReportModal(null);
            }, 3000);
        } else {
            throw new Error(response.payload?.message || "You have already reported this comment.");
        }
    };

    const getCommentRepliesByCommentId = async (commentId) => {
        try {
            await dispatch(getCommentReply({ commentId }));
        }
        catch (error) {
            console.error("Error fetching comment replies:", error);
        }
    };

    const handleDeleteNestedReply = async (nestedReplyId, replyId) => {
        try {
            await dispatch(deleteNestedReply({ nestedReplyId }));
            setTimeout(() => {
                setRepleyItemId(null);
                setReplay(false);
                setCreateReplay({ key: id, body: "" });
            }, 3000);
            getCommentRepliesByCommentId(replyId);
        } catch (error) {
            console.error("Error deleting nested reply:", error);
        }
    };

    const handleUpdateCommentReply = async () => {
        try {
            const response = await dispatch(updateCommentReply({ replyId: createReplay.key, value: createReplay.body }));

            if (response.type == "updateCommentReply/fulfilled") {
                setCommentPrev(null);
                setCreateReplay(() => ({
                    key: "", body: ""
                }));
                setEditReply((prev) => !prev);
                setRepleyItemId(null);
            }
        }

        catch (error) {
            console.error("Error updating comment reply:", error);
            // Extract the error message from the response
            const errorMessage = error?.payload?.message || "An error occurred while updating the comment reply.";
        }
    }

    const handleUpdateNestedReply = async () => {
        try {
            const response = await dispatch(updateNestedReply({ nestedReplyId: createReplay.key, value: createReplay.body }));
            if (response.type == "updateCommentReply/fulfilled") {
                setCommentPrev(null);
                setCreateReplay(() => ({
                    key: "", body: ""
                }));
                setEditNestedReply((prev) => !prev);
            }
        } catch (error) {
            console.error("Error updating nested reply:", error);
        }
    }

    const handleViewVideo = useCallback(async () => {
        try {
            await dispatch(videoView(id));
        } catch (error) {
            console.error("Error:", error);
        }
    }, [dispatch, id]);

    const postTrack = useCallback((payload) => {
        const basePayload = {
            liked: Boolean(likeEmoji),
            loop_count: loopCountRef.current,
        };
        const data = { ...basePayload, ...payload };
        const cookieSessionId = getSessionIdFromCookie();

        if (cookieSessionId) {
            sessionIdRef.current = cookieSessionId;
        }

        if (sessionIdRef.current) {
            data.sessionid = sessionIdRef.current;
            data.session_id = sessionIdRef.current;
        }
        if (userLogin) {
            dispatch(trackWatchVideo({ postId: id, data }))
                .then((action) => {
                    if (action?.payload?.session_id) {
                        sessionIdRef.current = action.payload.session_id;
                    }
                })
                .catch(() => { });
        };
    }, [dispatch, id, likeEmoji]);

    const sendInitialTracking = useCallback(() => {
        if (initialSentRef.current) return;
        if (!videoRef.current || videoRef.current.paused) return;
        const durationMs = Math.round((watchDurationRef.current || videoRef.current?.duration || 0) * 1000);
        if (!durationMs) return;
        initialSentRef.current = true;
        postTrack({ video_duration_ms: durationMs, surface: "home" });
    }, [postTrack]);

    const sendProgressTracking = useCallback((extra = {}) => {
        if (!videoRef.current || videoRef.current.paused) return;
        sendInitialTracking();
        const durationSec = watchDurationRef.current || videoRef.current?.duration || 0;
        const rawPositionSec = videoRef.current?.currentTime || 0;
        const trackedPositionSec = watchPositionRef.current || rawPositionSec;

        if (!durationSec && !trackedPositionSec) return;

        const positionMs = Math.round(trackedPositionSec * 1000);
        const durationMs = Math.round(durationSec * 1000);

        postTrack({
            ...(durationMs ? { video_duration_ms: durationMs } : {}),
            watch_time_ms: Math.min(positionMs, durationMs || positionMs),
            position_reached_ms: positionMs,
            surface: "home",
            ...extra,
        });
    }, [postTrack, sendInitialTracking]);

    const sendExitTracking = useCallback((reason = exitReasonHint || "swiped_away") => {
        if (lastExitReasonRef.current === reason) return;
        lastExitReasonRef.current = reason;

        const durationSec = watchDurationRef.current || videoRef.current?.duration || 0;
        const positionSec = watchPositionRef.current || videoRef.current?.currentTime || 0;
        // positionSec=0 means this video was never actually watched (e.g. a preloaded
        // slide that has a duration from HLS manifest but was never played). Skip it.
        if (!positionSec) return;

        const positionMs = Math.round(positionSec * 1000);
        const durationMs = Math.round((durationSec || positionSec) * 1000);
        // Only report the 50/95 milestone actually reached, never a computed/arbitrary percentage
        const watchPercentage = milestone95SentRef.current ? 95 : milestone50SentRef.current ? 50 : null;

        postTrack({
            ...(durationMs ? { video_duration_ms: durationMs } : {}),
            watch_time_ms: Math.min(positionMs, durationMs || positionMs),
            position_reached_ms: positionMs,
            ...(watchPercentage !== null ? { watch_percentage: watchPercentage } : {}),
            surface: "home",
            exit_reason: reason,
        });
    }, [exitReasonHint, postTrack]);

    // Fires once per video when playback crosses the 50%/95% watch marks
    const sendMilestoneTracking = useCallback((watchPercentage) => {
        const durationSec = watchDurationRef.current || videoRef.current?.duration || 0;
        const positionSec = watchPositionRef.current || videoRef.current?.currentTime || 0;
        const durationMs = Math.round(durationSec * 1000);
        const positionMs = Math.round(positionSec * 1000);

        postTrack({
            ...(durationMs ? { video_duration_ms: durationMs } : {}),
            watch_time_ms: Math.min(positionMs, durationMs || positionMs),
            position_reached_ms: positionMs,
            watch_percentage: watchPercentage,
            surface: "home",
        });
    }, [postTrack]);

    // Handle video ended event for autoplay to next video
    useEffect(() => {
        const video = videoRef.current;
        if (!video) {
            return;
        }

        const handleVideoEnded = () => {
            const isLooping = Boolean(videoRef.current?.loop);

            if (isLooping) {
                loopCountRef.current += 1;
                postTrack({
                    loop_count: loopCountRef.current,
                    surface: "home",
                });
                return;
            }

            setIsPlaying(false);
            sendExitTracking("completed");

            if (enableAutoplay && handleNext && typeof handleNext === 'function') {
                setTimeout(() => {
                    handleNext();
                }, 300);
            }
        };

        video.addEventListener('ended', handleVideoEnded);

        return () => {
            video.removeEventListener('ended', handleVideoEnded);
        };
    }, [id, enableAutoplay, handleNext, postTrack, sendExitTracking]);

    // Optimized profile navigation handler
    const handleNavigate = useMemo(() =>
        handleProfileNavigate(navigate, User_profile?.id),
        [navigate, User_profile?.id]
    );

    //optimized back navigation handler
    const handleGoBack = useCallback(() => {
        sendExitTracking("back_pressed");
        if (feedType) {
            navigate(prevPath, { state: { feedType } });
        } else {
            navigate(-1);
        }
    }, [feedType, navigate, prevPath, sendExitTracking]);

    // Handle browser back button to use custom navigation logic
    useEffect(() => {
        const handleBrowserBack = (event) => {
            event.preventDefault();

            sendExitTracking("back_pressed");

            if (prevPath) {
                navigate(prevPath);
            }
        };

        window.addEventListener('popstate', handleBrowserBack);

        return () => {
            window.removeEventListener('popstate', handleBrowserBack);
        };
    }, [feedType, prevPath, navigate, sendExitTracking]);

    // Optimized video control functions with better error handling
    const playVideo = (video) => {
        return new Promise((resolve, reject) => {
            if (!video) {
                resolve();
                return;
            }

            // If already playing, resolve immediately
            if (!video.paused) {
                resolve();
                return;
            }

            // Wait for any existing play promise to complete first
            if (playPromiseRef.current) {
                playPromiseRef.current
                    .then(() => {
                        // Now try to play again
                        playPromiseRef.current = video.play();
                        if (playPromiseRef.current) {
                            playPromiseRef.current
                                .then(() => {
                                    playPromiseRef.current = null;
                                    resolve();
                                })
                                .catch((error) => {
                                    playPromiseRef.current = null;
                                    // Handle all common play interruption errors
                                    if (error?.name === "AbortError" ||
                                        error?.name === "NotAllowedError" ||
                                        error?.message?.includes("interrupted")) {
                                        resolve();
                                        return;
                                    }
                                    reject(error);
                                });
                        } else {
                            resolve();
                        }
                    })
                    .catch(() => {
                        playPromiseRef.current = null;
                        resolve();
                    });
                return;
            }

            playPromiseRef.current = video.play();
            if (playPromiseRef.current !== undefined) {
                playPromiseRef.current
                    .then(() => {
                        playPromiseRef.current = null;
                        resolve();
                    })
                    .catch((error) => {
                        playPromiseRef.current = null;
                        // Handle all common play interruption errors
                        if (error?.name === "AbortError" ||
                            error?.name === "NotAllowedError" ||
                            error?.name === "NotSupportedError" ||
                            error?.message?.includes("interrupted")) {
                            resolve();
                            return;
                        }
                        reject(error);
                    });
            } else {
                playPromiseRef.current = null;
                resolve();
            }
        });
    };

    const pauseVideo = (video) => {
        return new Promise((resolve, reject) => {
            if (!video || video.paused) {
                resolve(); // Already paused or no video element
                return;
            }

            // Wait for any ongoing play promise to complete before pausing
            if (playPromiseRef.current) {
                playPromiseRef.current
                    .then(() => {
                        playPromiseRef.current = null;
                        try {
                            video.pause();
                            resolve();
                        } catch (error) {
                            reject(error);
                        }
                    })
                    .catch((error) => {
                        playPromiseRef.current = null;
                        // Even if play failed, try to pause
                        try {
                            video.pause();
                            resolve();
                        } catch (pauseError) {
                            reject(pauseError);
                        }
                    });
                return;
            }

            try {
                video.pause();
                resolve();
            } catch (error) {
                reject(error);
            }
        });
    };

    // HLS setup: attach hls.js for .m3u8 streams
    useEffect(() => {
        const video = videoRef.current;
        if (!video || !src) return;

        let hls;
        if (src.includes(".m3u8")) {
            if (Hls.isSupported()) {
                hls = new Hls({
                    // Quality / ABR
                    startLevel: -1,               // auto-select quality based on current bandwidth
                    abrEwmaFastLive: 3,
                    abrEwmaSlowLive: 9,
                    abrBandWidthFactor: 0.95,
                    abrBandWidthUpFactor: 0.7,

                    // Buffer: keep it lean for short-form video
                    maxBufferLength: 10,          // buffer up to 10s of chunks ahead
                    maxMaxBufferLength: 30,       // hard cap

                    // Chunk (fragment) loading: timeouts + retries
                    fragLoadingTimeOut: 10000,         // 10s before a chunk download is considered hung
                    fragLoadingMaxRetry: 3,            // retry a failed chunk up to 3 times
                    fragLoadingRetryDelay: 500,        // 500ms between retries
                    fragLoadingMaxRetryTimeout: 4000,  // cap retry back-off at 4s

                    // Manifest loading retries
                    manifestLoadingTimeOut: 10000,
                    manifestLoadingMaxRetry: 2,
                    manifestLoadingRetryDelay: 500,
                });
                hls.loadSource(src);
                hls.attachMedia(video);

                hls.on(Hls.Events.MANIFEST_PARSED, (_event, data) => {
                    // isActiveRef.current is always fresh — avoids stale closure bug
                    // where a preloaded slide would auto-play via this callback.
                    if (isVideoInViewRef.current && isActiveRef.current && video.paused) {
                        video.play().catch(() => { });
                    }
                });

                hls.on(Hls.Events.LEVEL_SWITCHED, (_event, data) => {
                    const level = hls.levels[data.level];
                    const bwEstimate = hls.bandwidthEstimate;
                });

                hls.on(Hls.Events.FRAG_LOADED, (_event, data) => {
                    const bwEstimate = hls.bandwidthEstimate;
                    const frag = data.frag;
                });

                let mediaErrorRecovered = false;
                hls.on(Hls.Events.ERROR, (_event, data) => {
                    if (!data.fatal) return;

                    console.error("[Video] hls.js fatal error", { type: data.type, details: data.details, src });

                    // Manifest failed to load — CORS (0), 403, 404 won't recover by retrying
                    if (data.details === Hls.ErrorDetails.MANIFEST_LOAD_ERROR ||
                        data.details === Hls.ErrorDetails.MANIFEST_LOAD_TIMEOUT) {
                        hls.destroy();
                        return;
                    }

                    switch (data.type) {
                        case Hls.ErrorTypes.NETWORK_ERROR:
                            hls.startLoad();
                            break;
                        case Hls.ErrorTypes.MEDIA_ERROR:
                            if (!mediaErrorRecovered) {
                                mediaErrorRecovered = true;
                                hls.recoverMediaError();
                            } else {
                                hls.swapAudioCodec();
                                hls.recoverMediaError();
                            }
                            break;
                        default:
                            hls.destroy();
                            break;
                    }
                });
            } else if (video.canPlayType("application/vnd.apple.mpegurl")) {
                video.src = src;
            } else {
                console.error("[Video] m3u8 detected but HLS is not supported on this browser", src);
            }
        } else {
            video.src = src;
        }

        return () => {
            if (hls) {
                hls.destroy();
            }
        };
    }, [src]);

    useEffect(() => {
        const video = document.getElementById(`video-${id}`);
        const postMainElement = document.getElementById(`post-main-${id}`);

        if (video && postMainElement) {
            const observer = new IntersectionObserver(
                (entries) => {
                    const entry = entries && entries[0];
                    if (!entry) return;

                    if (entry.isIntersecting && !showWelcome) {
                        isVideoInViewRef.current = true;
                        setIsVideoInView(true);
                    } else {
                        isVideoInViewRef.current = false;
                        setIsVideoInView(false);
                        // Only track + pause if this slide was actually the active one.
                        // Off-screen preloaded slides (isActive=false) should never
                        // fire tracking or attempt to pause — they were never playing.
                        if (isActiveRef.current) {
                            sendExitTracking(exitReasonHint);
                            pauseVideo(video)
                                .then(() => {
                                    closeDrawerBottomCommments();
                                    closeDrawerBottom();
                                })
                                .catch((error) => {
                                    console.error(
                                        "Error occurred while trying to pause video:",
                                        error
                                    );
                                });
                        }
                    }
                },
                { threshold: [0.6] }
            );

            observer.observe(postMainElement);

            return () => {
                // Cleanup: cancel any ongoing play promise
                if (playPromiseRef.current) {
                    playPromiseRef.current.catch(() => { }); // Suppress errors
                    playPromiseRef.current = null;
                }
                observer.disconnect();
            };
        } else {
            setIsVideoInView(false);
        }
    }, [id, showWelcome, exitReasonHint, sendExitTracking]);

    useEffect(() => {
        // isActive gates play for off-screen preloaded slides in the sliding window
        if (!isVideoInView || showWelcome || !isActive) {
            return;
        }

        const video = document.getElementById(`video-${id}`);
        if (!video) {
            return;
        }

        const attemptPlay = async () => {
            try {
                await playVideo(video);
            } catch (error) {
                if (error?.name === "NotAllowedError") {
                    if (error?.name !== "AbortError" && !error?.message?.includes("interrupted")) {
                        console.error("Error occurred while trying to play video:", error);
                    }
                    return;
                }
                if (error?.name === "AbortError" || error?.message?.includes("interrupted")) {
                    return;
                }
            }
        };

        attemptPlay();

        return () => {
            if (playPromiseRef.current) {
                playPromiseRef.current.catch(() => { });
            }
        };
    }, [id, isVideoInView, showWelcome, hasUserInteracted, isActive]);

    // Keep isActiveRef in sync so closures inside other effects (e.g. HLS
    // MANIFEST_PARSED) always read the current value instead of a stale capture.
    useEffect(() => {
        isActiveRef.current = isActive;
    }, [isActive]);

    // Immediately pause when this slide is no longer the active one.
    // Without this, the exiting video keeps playing audio during the transition.
    useEffect(() => {
        if (isActive) return;
        const video = videoRef.current;
        if (!video || video.paused) return;
        if (playPromiseRef.current) {
            playPromiseRef.current.then(() => {
                video.pause();
                setIsPlaying(false);
            }).catch(() => { });
        } else {
            try {
                video.pause();
                setIsPlaying(false);
            } catch (e) { }
        }
    }, [isActive]);

    useEffect(() => {
        const handleMenuOutsideClick = (event) => {
            if (menuRef.current && !menuRef.current.contains(event.target)) {
                setMenuCommentId(null);
            }
        };
        document.addEventListener("mousedown", handleMenuOutsideClick);
        return () => {
            document.removeEventListener("mousedown", handleMenuOutsideClick);
        };
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (textRef.current && !textRef.current.contains(event.target)) {
                setShowMore(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);

        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    // Video ended handler removed - now handled by autoplay logic above
    // to prevent conflicts between looping and autoplay functionality

    // Optimized time update handler with better debouncing
    const handleTimeUpdate = useCallback(() => {
        const video = videoRef.current;
        if (!video || !video.duration) return;

        if (timeUpdateRef.current) {
            cancelAnimationFrame(timeUpdateRef.current);
        }

        timeUpdateRef.current = requestAnimationFrame(() => {
            const currentTime = video.currentTime || 0;
            const totalDuration = video.duration || 0;

            watchPositionRef.current = Math.max(watchPositionRef.current, currentTime);

            if (totalDuration) {
                watchDurationRef.current = totalDuration;
                sendInitialTracking();

                const percentWatched = (currentTime / totalDuration) * 100;
                if (!milestone50SentRef.current && percentWatched >= 50) {
                    milestone50SentRef.current = true;
                    sendMilestoneTracking(50);
                }
                if (!milestone95SentRef.current && percentWatched >= 95) {
                    milestone95SentRef.current = true;
                    sendMilestoneTracking(95);
                }
            }

            if (!isDragging) {
                if (Math.abs(lastProgressRef.current - currentTime) >= 0.2 || currentTime === 0) {
                    lastProgressRef.current = currentTime;
                    setProgress(currentTime);
                }
            }

            if (Math.abs(lastDurationRef.current - totalDuration) >= 0.5 || lastDurationRef.current === 0) {
                lastDurationRef.current = totalDuration;
                setDuration(totalDuration);
            }

            if (!viewAPITriggered) {
                const requiredWatchTime = 1;
                if (currentTime >= requiredWatchTime && userLogin) {
                    handleViewVideo();
                    setViewAPITriggered(true);
                }
            }

            const lastTime = lastPlaybackTimeRef.current;
            if (totalDuration && lastTime > totalDuration - 0.4 && currentTime < 0.3) {
                loopCountRef.current += 1;
                postTrack({
                    loop_count: loopCountRef.current,
                    surface: "home",
                });
            }

            lastPlaybackTimeRef.current = currentTime;

            // // Video view API call optimization
            // if (!viewAPITriggered && video.currentTime >= 4) {
            //     handleViewVideo();
            //     setViewAPITriggered(true);
            // }
        });
    }, [duration, isDragging, viewAPITriggered, handleViewVideo, postTrack, sendInitialTracking, sendMilestoneTracking]);

    const [isLoading, setIsLoading] = useState(true);

    const handleCanPlay = useCallback(() => {
        setIsLoading(false);
        onVideoReady?.();
        if (videoRef.current?.duration) {
            watchDurationRef.current = videoRef.current.duration;
        }
    }, [onVideoReady]);

    const handlePlaying = useCallback(() => {
        setIsLoading(false);
        onVideoReady?.();
        setIsPlaying(true);
        if (videoRef.current?.duration) {
            watchDurationRef.current = videoRef.current.duration;
            sendInitialTracking();
        }
    }, [sendInitialTracking, onVideoReady]);

    // Pre-buffered case: video was already ready before it became the active slide
    useEffect(() => {
        if (isActive && !isLoading) {
            onVideoReady?.();
        }
    }, [isActive]); // eslint-disable-line react-hooks/exhaustive-deps

    const handlePause = useCallback(() => {
        setIsPlaying(false);
    }, []);

    // Format time in MM:SS - Memoized to prevent unnecessary calculations
    const formatTime = useCallback((time) => {
        const minutes = Math.floor(time / 60);
        const seconds = Math.floor(time % 60);
        return `${minutes}:${seconds.toString().padStart(2, "0")}`;
    }, []);

    // Handle user manually changing progress
    const handleSeek = useCallback((e) => {
        const newTime = Number(e.target.value);
        lastProgressRef.current = newTime;
        setProgress(newTime);
        if (videoRef.current) {
            videoRef.current.currentTime = newTime;
        }
        watchPositionRef.current = Math.max(watchPositionRef.current, newTime);
        if (videoRef.current && !videoRef.current.paused && userLogin) {
            sendProgressTracking();
        }
    }, [sendProgressTracking]);

    const handleRangeStart = useCallback((event) => {
        setIsDragging(true);
        if (typeof handleSliderStart === "function") {
            handleSliderStart(event);
        }
    }, [handleSliderStart]);

    const handleRangeEnd = useCallback((event) => {
        setIsDragging(false);
        if (typeof handleSliderEnd === "function") {
            handleSliderEnd(event);
        }
    }, [handleSliderEnd]);

    const safePlaybackSpeed = Number.isFinite(playbackSpeed) ? playbackSpeed : 1;

    useEffect(() => {
        if (videoRef.current) {
            videoRef.current.playbackRate = safePlaybackSpeed;
        }
    }, [safePlaybackSpeed]);

    // Periodic progress tracking while in view
    useEffect(() => {
        const shouldTrack = isVideoInView && hasUserInteracted && isPlaying;

        if (shouldTrack && !progressIntervalRef.current) {
            progressIntervalRef.current = setInterval(() => {
                // Guard in case state changes between ticks
                if (!videoRef.current || videoRef.current.paused) return;
                sendProgressTracking();
            }, 5000);
        }

        if (!shouldTrack && progressIntervalRef.current) {
            clearInterval(progressIntervalRef.current);
            progressIntervalRef.current = null;
        }

        return () => {
            if (progressIntervalRef.current) {
                clearInterval(progressIntervalRef.current);
                progressIntervalRef.current = null;
            }
        };
    }, [isVideoInView, hasUserInteracted, isPlaying, sendProgressTracking]);

    // Cleanup animation frame and send exit tracking on unmount
    useEffect(() => {
        return () => {
            if (timeUpdateRef.current) {
                cancelAnimationFrame(timeUpdateRef.current);
            }
            const reason = lastExitReasonRef.current || exitReasonHint;
            sendExitTracking(reason);
        };
    }, [exitReasonHint, sendExitTracking]);

    // App minimized / tab hidden — actually pause playback so video/audio
    // doesn't keep running in the background, and resume it when the tab
    // becomes visible again if this slide is still the active, in-view one.
    useEffect(() => {
        const handleVisibility = () => {
            const video = videoRef.current;
            if (document.hidden) {
                sendExitTracking("app_minimized");
                if (video && !video.paused) {
                    pauseVideo(video).catch(() => { });
                }
            } else {
                if (lastExitReasonRef.current === "app_minimized") {
                    lastExitReasonRef.current = null;
                }
                if (video && video.paused && isVideoInViewRef.current && isActiveRef.current) {
                    playVideo(video).catch(() => { });
                }
            }
        };

        document.addEventListener("visibilitychange", handleVisibility);
        return () => {
            document.removeEventListener("visibilitychange", handleVisibility);
        };
    }, [sendExitTracking]);

    // Optimized video click handler
    const handleVideoClick = useCallback(() => {
        if (videoRef.current) {
            if (videoRef.current.paused) {
                playVideo(videoRef.current).catch((error) => {
                    console.error("Error playing video on click:", error);
                });
            } else {
                pauseVideo(videoRef.current).catch((error) => {
                    console.error("Error pausing video on click:", error);
                });
            }
        }
    }, []);

    // Optimized hover handlers to prevent unnecessary re-renders
    const handleMouseEnterTimeline = useCallback(() => setIsHovered(true), []);
    const handleMouseLeaveTimeline = useCallback(() => setIsHovered(false), []);

    // Memoize progress calculations to prevent unnecessary re-calculations
    const progressPercentage = useMemo(() => {
        return duration > 0 ? (progress / duration) * 100 : 0;
    }, [progress, duration]);

    const formattedCurrentTime = useMemo(() => formatTime(progress), [progress, formatTime]);
    const formattedDuration = useMemo(() => formatTime(duration), [duration, formatTime]);

    return (
        <>
            <div
                id={`post-main-${id}`}
                // className="h-[90dvh] md:h-[82dvh] w-full relative overflow-hidden"
                className="h-full w-full relative overflow-hidden"
            >
                {showWelcome && (
                    <div className="absolute w-[100%] h-[100%] z-50">
                        <WelcomeModal onClose={() => handleReadUserStatus()} />
                    </div>
                )}

                {/* */}
                {(reported || reportedPostIdsRef?.current?.has(id)) && (
                    <div className="absolute inset-0 z-50 flex items-center justify-center bg-black/55 backdrop-blur-md px-4">
                        <div className="w-full max-w-sm rounded-2xl bg-white/95 dark:bg-gray-900/95 shadow-2xl p-5 text-center space-y-4">
                            <p className="text-base font-semibold text-gray-900 dark:text-white">
                                Your Report has been submitted.
                            </p>
                            <p className="text-xs leading-5 text-gray-700 dark:text-gray-200">
                                The Chaa Chingg Team will review this post and take action soon. You can view the status of your report in your Report Center.
                            </p>
                            <div className="flex items-center justify-center gap-3">
                                <button
                                    type="button"
                                    onClick={handleCloseReportSuccess}
                                    className="flex-1 rounded-lg bg-[#bde6ff] px-4 py-2 text-sm font-semibold text-gray-900 shadow-md"
                                >
                                    Show Post
                                </button>
                                <button
                                    type="button"
                                    onClick={handleOpenReportCenter}
                                    className="flex-1 rounded-lg bg-[#bde6ff] px-4 py-2 text-sm font-semibold text-gray-900 shadow-md"
                                >
                                    Report Center
                                </button>
                            </div>
                        </div>
                    </div>
                )}

                {/* Back Button */}
                {itsNotHome &&
                    <IoCaretBackCircleSharp
                        onClick={() => handleGoBack()}
                        className="absolute text-2xl top-3 left-3 z-50 text-white cursor-pointer"
                    />
                }

                {(videos.length === 0 && yourFeeds) &&
                    !loading ?
                    <div className="bg-black absolute h-full w-full z-10">
                        <p className="text-white text-[12px] absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 text-center px-4">
                            No videos available. Start following friends to view theirs.
                        </p>
                    </div> :
                    null
                }

                {(videos.length === 0 && yourFeeds) ?
                    null :
                    <video
                        poster={thumbnail_url}
                        playsInline
                        preload="auto"
                        ref={videoRef}
                        controls={false}
                        id={`video-${id}`}
                        type={"video/mp4"}
                        autoPlay={false}
                        muted={isMuted}
                        loop={!enableAutoplay}
                        disableRemotePlayback
                        disablePictureInPicture
                        x-webkit-airplay="deny"
                        webkit-playsinline="true"
                        onCanPlay={handleCanPlay}
                        onPlaying={handlePlaying}
                        onPause={handlePause}
                        onClick={handleVideoClick}
                        onTimeUpdate={handleTimeUpdate}
                        onError={(e) => {
                            // Suppress play/pause interruption errors
                            if (e.target?.error?.message?.includes("interrupted")) {
                                e.stopPropagation();
                                e.preventDefault();
                            }
                        }}
                        onContextMenu={(e) => e.preventDefault()}
                        controlsList="nodownload noplaybackrate nofullscreen noremoteplayback"
                        style={{
                            maxWidth: "100%",
                            WebkitAppearance: "none",
                            outline: "none",
                            willChange: "transform"
                        }}
                        className="w-full h-full object-cover hide-video-controls safari-no-controls"
                    />
                }

                {/* Thumbnail overlay — covers the black frame while HLS buffers */}
                {isLoading && thumbnail_url && (
                    <img
                        src={thumbnail_url}
                        alt=""
                        aria-hidden="true"
                        className="absolute inset-0 w-full h-full object-cover z-10 pointer-events-none"
                    />
                )}

                {/* share popup */}
                <Share
                    postId={id}
                    videoUrl={`${src}`}
                    openBottom={openBottom}
                    download_enabled={download_enabled}
                    closeDrawerBottom={closeDrawerBottom}
                    handleReshared={handleReshared}
                    userreshared={userreshared}
                    playbackSpeed={playbackSpeed}
                    setPlaybackSpeed={setPlaybackSpeed}
                    createdById={created_by?.id}
                    onReportSuccess={handleReportSuccess}
                />

                {/* comments popup */}
                <Comments
                    openBottomComments={openBottomComments}
                    closeDrawerBottomCommments={closeDrawerBottomCommments}
                    comments={comments}
                    commentsData={commentsData}
                    setCommentsData={setCommentsData}
                    handleChangeComment={handleChangeComment}
                    handleChangeReply={handleChangeReply}
                    menuCommentId={menuCommentId}
                    emptyComments={emptyComments}
                    menuRef={menuRef}
                    created_by={created_by}
                    handleChangeEditComment={handleChangeEditComment}
                    handleUpdateCommentReply={handleUpdateCommentReply}
                    handleUpdateNestedReply={handleUpdateNestedReply}
                    editNestedReply={editNestedReply}
                    editReply={editReply}
                    toggleMenu={toggleMenu}
                    handleChangeDeleteComment={handleChangeDeleteComment}
                    setMenuCommentId={setMenuCommentId}
                    handleSubmitComment={handleSubmitComment}
                    createCommet={createCommet}
                    createReplay={createReplay}
                    handleChangeRepleyComment={handleChangeRepleyComment}
                    handleEditReply={handleEditReply}
                    handleOpenreplay={handleOpenreplay}
                    repleyitemId={repleyitemId}
                    originalURL={originalURL}
                    replay={replay}
                    setReplay={setReplay}
                    setReportModal={setReportModal}
                    postId={id}
                    handleSubmitReplay={handleSubmitReplay}
                    commentPrev={commentPrev}
                    handleCloseReply={handleCloseReply}
                    closeEditComment={closeEditComment}
                    EditComment={EditComment}
                    getCommentRepliesByCommentId={getCommentRepliesByCommentId}
                    replyDelete={deleteCommentReply}
                    deleteNestedReply={handleDeleteNestedReply}
                    comments_enabled={comments_enabled}
                    setBlockUser={setBlockUser}
                />


                {/* Bottom Controls */}
                <div className="absolute bottom-0 w-full pb-1 bg-gradient-to-t from-black bg-opacity-30 z-20">
                    {/* Video Description and User Info */}
                    <div className="w-full pb-4">
                        <div className={`flex ${showMore ? "items-end" : "items-end"} justify-between px-2`}>
                            <div className="w-[80%]">
                                <p
                                    onClick={() => !userLogin ? handleInteraction() : handleNavigate(created_by?.id)}
                                    className="text-white font-bold text-[14px] cursor-pointer"
                                >
                                    {created_by?.full_name}
                                </p>
                                <div
                                    ref={textRef}
                                    className={`text-[12px] pt-1 text-white w-[100%] leading-4 ${showMore ? "min-h-[40px] max-h-[150px] overflow-y-auto" : "max-h-[20px] overflow-hidden"}`}
                                >
                                    {DescriptionContent}

                                    {(!isLongText || showMore) && HashtagList}
                                    {showMore && (
                                        <span
                                            onClick={handleShowMore}
                                            className="text-[12px] block mt-1 cursor-pointer font-bold text-cyan-500 hover:text-cyan-400"
                                        >
                                            Show less
                                        </span>
                                    )}
                                </div>
                                {resharedPostId === id && rehsaredMesaage && showReshareMessage && (
                                    <p className="absolute right-14 top-[1.3rem] flex items-center text-[10px] font-bold text-black text-center bg-white px-[5px] py-[2px] rounded-md">
                                        {rehsaredMesaage}
                                    </p>
                                )}
                                <p>
                                    {created_at && (
                                        <span className="text-gray-200 text-[10px] mr-1">
                                            {timeAgo(created_at)}
                                        </span>
                                    )}
                                </p>
                            </div>

                            <div className="flex flex-col relative items-center">
                                {followLoading &&
                                    <div className="flex items-center justify-center absolute top-[-20px] bg-gray-800 py-[2px] px-[4px] rounded-md">
                                        <p className="text-[8px] text-white">
                                            Followed
                                        </p>
                                    </div>
                                }
                                {created_by?.avatar_url && <>
                                    <img
                                        alt="image"
                                        src={`${created_by?.avatar_url}`}
                                        onClick={() => !userLogin ? handleInteraction() : handleNavigate(created_by?.id)}
                                        className="object-cover w-10 h-10 rounded-full bg-gray-200 cursor-pointer"
                                    />

                                    {created_by?.id !== User_profile.id && (
                                        <div className="absolute -top-2 -right-2.5 h-[25px] w-[25px] cursor-pointer">
                                            {usersfollowing === false &&
                                                <Button
                                                    className={`w-[20px] h-[20px] rounded-full flex justify-center items-center p-0
                                                    ${usersfollowing ? "bg-gray-700" : "bg-black"}`}
                                                >
                                                    <TiUserAddOutline
                                                        onClick={() => handleFollowClick(created_by?.id)}
                                                        className="w-[15px] h-[15px] text-white"
                                                    />
                                                </Button>
                                            }
                                        </div>
                                    )}
                                </>}
                            </div>
                        </div>
                    </div>

                    {/* Video Footer Icons */}
                    <div className="flex justify-between px-2 pb-2 w-full">
                        {videoFootageSideIcon?.map((item, index) => (
                            <div key={index} className="text-white  items-end flex justify-center w-10">
                                <div className={`flex fle-start flex-col items-center`}>
                                    <p
                                        onClick={() => handleSetPage(item?.text)}
                                        className="text-[#ffff] text-[10px] font-semibold"
                                    >
                                        {item?.text === "Like" && !hideOwnLikeCount && (
                                            <span className="pr-[2px]">{formatCount(likeCount)}</span>
                                        )}
                                        {item?.text === "Comment" && comments_enabled && (
                                            <span className="pr-[2px]">
                                                {formatCount(commentCount)}
                                            </span>
                                        )}
                                    </p>
                                    <div className="pb-1">
                                        {item?.icon && item?.text === "Like" ? (
                                            <p
                                                onClick={() => handleSetPage(item?.text)}
                                                className={`cursor-pointer text-[1.2rem] transition-all 
                                                    ${likeEmoji ? "text-red-500" : "text-white"}
                                                    ${isLikeAnimating ? "animate-like-button" : ""}`
                                                }
                                            >
                                                {likeEmoji ? <FaHeart /> : <FaRegHeart />}
                                            </p>
                                        ) : (
                                            item?.text === "Comments" ? <p
                                                onClick={() => handleSetPage(item?.text)}
                                                className={`cursor-pointer text-[1.2rem] transition-all 
                                                ${likeEmoji ? "text-cyan-500" : "text-white"}
                                                ${isLikeAnimating ? "animate-like-button" : ""}`
                                                }
                                            >
                                                {comments_enabled ? item?.icon : null}
                                            </p>
                                                :
                                                <p
                                                    onClick={() => item?.text === "Repost" ? handleRepostWithAnimation(id) : handleSetPage(item?.text)}
                                                    className={`text-[1.2rem] cursor-pointer transition-all 
                                                    ${item.text === "Save" ? (isSaved ? "text-cyan-500" : "text-white") : ""}
                                                    ${item.text === "Repost" ? (isReshared ? "text-cyan-500" : "text-white") : ""}
                                                    ${item.text === "Repost" && isRepostAnimating ? "animate-repost-button" : ""}`}
                                                >
                                                    {item?.icon}
                                                </p>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Custom Timeline Bar */}
                    <div
                        className="h-1 w-full rounded-full bg-gray-400"
                        onMouseEnter={handleMouseEnterTimeline}
                        onMouseLeave={handleMouseLeaveTimeline}
                    >
                        <div
                            style={{ width: `${progressPercentage}%` }}
                            className="absolute h-1 rounded-full bg-blue-500 transition-all duration-200"
                        />

                        <div
                            className="absolute z-10 bottom-0 -translate-x-1/2 -translate-y-1/2 transform cursor-pointer rounded-full bg-white shadow-lg"
                            style={{ left: `${progressPercentage}%`, top: "2px" }}
                        >
                            {isHovered && formattedCurrentTime !== formattedDuration && (
                                <div className={`absolute -bottom-8 ${progressPercentage === 0 ? "left-12" : "left-1/2"} z-50 whitespace-nowrap -translate-x-1/2 transform rounded bg-gray-900 px-2 pt-1 text-[10px] text-white shadow`}>
                                    {formattedCurrentTime} / {formattedDuration}
                                </div>
                            )}
                        </div>

                        <input
                            type="range"
                            min="0"
                            max={duration}
                            value={progress}
                            onInput={handleSeek}
                            className="absolute w-full cursor-pointer opacity-0"
                            onMouseDown={handleRangeStart}
                            onMouseUp={handleRangeEnd}
                            onTouchStart={handleRangeStart}
                            onTouchEnd={handleRangeEnd}
                        />
                    </div>
                </div>

                {reportModal && (
                    <CommentReport setReportPost={handleCloseReportModal} handleReportComment={handleReportComment} />
                )}

                {/* Block Confirmation Modal */}
                {showBlockConfirm && userToBlock && (
                    <div className="absolute h-[82vh] inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center">
                        <div className="bg-white h-auto py-4 dark:bg-gray-900 shadow-lg rounded-lg w-[300px] flex flex-col items-center justify-center">
                            <p className="text-[24px] font-bold text-black dark:text-white text-center mb-2">
                                Block {userToBlock.full_name}?
                            </p>
                            <p className="text-[12px] text-black px-4 dark:text-white text-center">
                                Are you sure you want to block {userToBlock.full_name}? They will not be able to send you messages,
                                find your profile, or see your posts and they will not be notified that you blocked them.
                            </p>
                            <div className="flex gap-2 mt-4">
                                <Button
                                    onClick={handleBlockCancel}
                                    size="sm"
                                    className="bg-[#1b1b1b] dark:bg-gray-400 dark:text-black dark:hover:bg-gray-500 hover:bg-[#0f0f0f] text-white"
                                >
                                    Cancel
                                </Button>
                                <Button
                                    onClick={handleBlockConfirm}
                                    size="sm"
                                    className="bg-red-900 hover:bg-red-600 text-white"
                                >
                                    Block
                                </Button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
};

// Custom comparison function to prevent unnecessary re-renders
const arePropsEqual = (prevProps, nextProps) => {
    // Only re-render if critical props change
    const criticalProps = [
        'id', 'src', 'user_liked', 'user_saved', 'userreshared', 'userfollowing',
        'comments_enabled', 'download_enabled', 'playbackSpeed', 'showWelcome', 'dec', 'exitReasonHint',
        'resharedPostId', 'rehsaredMesaage', 'isFollow', 'newUser', 'enableAutoplay', 'userLogin', 'isActive'
    ];

    for (const prop of criticalProps) {
        if (prevProps[prop] !== nextProps[prop]) {
            return false;
        }
    }

    // Check created_by object
    if (prevProps.created_by?.id !== nextProps.created_by?.id ||
        prevProps.created_by?.avatar_url !== nextProps.created_by?.avatar_url ||
        prevProps.created_by?.full_name !== nextProps.created_by?.full_name) {
        return false;
    }

    return true;
};

export default memo(HomeVideoView, arePropsEqual);
